import React, { useEffect, useState } from "react";
import Constants from "../Variables/Constants";
import axios from "axios";
import { toast } from "react-toastify";
import { set } from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import SelectToCompare from "./SelectToCompare";
import { useDispatch } from "react-redux";
import { setCartItems } from "../../redux/cartSlice";
import qs from "qs";
import Loader from "../../components/Loader";
import { getUniqueId } from "../../utils";

const CompareCustomDesign = () => {
  const location = useLocation();
  const [images, setImages] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [categoryId, setCategoryId] = useState("");
  const [collectionId, setCollectionId] = useState("");
  const [categoryData, setCategoryData] = useState("");
  const [collectionName, setCollectionName] = useState("");
  const getCategoryDetail = async () => {
    try {
      setLoader(true);
      const resp = await axios.get(
        `${Constants.getUrls.getAllCategory}/${categoryId}`
      );
      if (resp.data.status === "success") {
        setCategoryData(resp?.data?.data);
        setLoader(false);
      } else {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(resp.data.message);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  useEffect(() => {
    if (categoryId) {
      getCategoryDetail();
    }
  }, [categoryId]);
 
  useEffect(() => {
    if (location && location.search) {
      const queryParams = location.search.trim().split("?").join("").trim();
      const obj = qs.parse(queryParams);
      setCategoryId(obj?.categoryId || null);
      setCollectionId(obj?.collectionId || null);
      setCollectionName(obj?.collectionName || null);
    }

  }, [location]);

  // Fetch images from the backend
  const fetchImages = async () => {
    try {
      const response = await axios.get(
        Constants.getUrls.getAllCustomizedImage,
        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        }
      );
      if (response.data.status === "success") {
        const data = response.data.data;
        if (data && Array.isArray(data)) {
          setImages(data);
        } else {
          toast.clearWaitingQueue();
          toast.dismiss();
          toast.error("Invalid data format received from the server.");
          setImages([]);
        }
      } else {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error fetching images:", error);
    }
  };

  useEffect(() => {
    fetchImages();
  }, []);

  // Handle removing an image
  const handleRemove = async (product) => {
    try {
      const response = await axios.delete(
        `${Constants.deleteUrls.removeCustomizedImage}/${product._id}`,
        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        }
      );
      if (response.data.status === "success") {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.success("Image removed successfully!", {
          style: { backgroundColor: "green", color: "white" },
        });
        fetchImages();
      } else {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error deleting image:", error);
    }
  };

  const fetchCart = async () => {
    try {
      const res = await axios.get(Constants.getUrls.getCart, {
        headers: { Authorization: localStorage.getItem("token") },
      });
      if (res.data.status === "success") {
        const data = res.data.data.docs;
        const arr = [];
        if (data && Array.isArray(data) && data.length > 0) {
          data.map((item) => {
            arr.push({
              _id: item._id,
              product_id: item.product_id._id,
              images: item.product_id.images,
              name: item.product_id.name,
              price: item.product_id.price,
              quantity: item.quantity,
            });
          });
          dispatch(setCartItems(arr));
          localStorage.removeItem("cart");
        } else {
          dispatch(setCartItems([]));
          localStorage.removeItem("cart");
        }
      } else {
        dispatch(setCartItems([]));
        localStorage.removeItem("cart");
      }
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  const handleAddToCart = async (image) => {
    try {
      setLoader(true);
      const formData = new FormData();

      formData.append("name", `custom-${categoryData.title}-${getUniqueId()}`);
      formData.append("category", categoryId);
      formData.append("sub_category", collectionId);
      formData.append("description", "This is a custom product");
      formData.append("image_url", image.customized_image);
      formData.append("quantity", 1);
      formData.append("matching_bag", image.matching_bag);
      formData.append("price", image.price);
      formData.append("offer_price", image.price);
      formData.append("status", "active");
      if (image.main_fabric_id) {
        formData.append("main_fabric_id", image.main_fabric_id);
      }
      if (image._id) {
        formData.append("customize_image_id", image._id);
      }
      if (image.size_id) {
        formData.append("size_id", image.size_id);
      }

      const response = await axios.post(
        Constants.postUrls.addProducts,
        formData,
        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        }
      );

      if (response.data.status === "success") {
        const newProd = response.data.data;

        axios
          .post(
            Constants.postUrls.AddToCart,
            {
              product_id: newProd._id,
              quantity: 1,
              customized_image_id: image._id || null,
            },
            {
              headers: {
                Authorization: localStorage.getItem("token"),
              },
            }
          )
          .then((resp) => {
            if (resp.data.status === "success") {
              toast.clearWaitingQueue();
              toast.dismiss();
              toast.success("Product added to cart successfully!", {
                style: { backgroundColor: "green", color: "white" },
              });
              fetchCart();
            }
          })
          .catch((error) => {
            console.error("Error while adding product to cart:", error);
          });
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="">
      {loader && <Loader />}
      {/* <div className="row mt-5">
        {images.map((image) => (
          <div
            key={image._id}
            className="col-12 col-md-6 d-flex flex-column align-items-center mb-4"
          >
            <img loading="lazy" 
              src={`${Constants.imgDomain}${image.customized_image}`}
              alt="Customized"
              style={{
                width: "100%",
                height: "auto", objectFit: "cover"
              }}
            // onClick={() => handleImageClick(image)}
            />
            <div>
              <button
                className="btn btn-danger mt-4 mb-5 me-3"
                onClick={() => handleRemove(image._id)}
              >
                Remove
              </button>
              <button
                className="btn btn-warning mt-4 mb-5 me-3"
                onClick={() => handleAddToCart(image)}
              >
                Add To Cart
              </button>
              <button
                className="btn btn-warning mt-4 mb-5"
                onClick={() => navigate(`/build_your_custom_beteil/${image.product_id}/product`, {
                  state: { designData: image }
                })}
              >
                Edit
              </button>
            </div>
          </div>
        ))}
      </div> */}
      <>
        <SelectToCompare
          images={images}
          handleAddToCart={handleAddToCart}
          handleRemove={handleRemove}
          categoryId={categoryId}
          collectionId={collectionId}
          categoryData={categoryData}
          collectionName={collectionName}
        />
      </>
    </div>
  );
};

export default CompareCustomDesign;
